import ReportsAddressTable from './ReportsAddressTable'

export default ReportsAddressTable
